import React from 'react';
import { TWILIGHT_NAVY, MUTED_GOLD, SHELL_WHITE, alpha } from '../../../theme/colors';
import { SCIENCE_EYEBROW, HEADLINE_REGULAR, HEADLINE_ITALIC, MISSION_TEXT, SCIENCE_BEATS, CLOSING_STATEMENT, REFERENCES, REFERENCES_DISCLAIMER } from './scienceData';

const DIVIDER = `1px solid ${alpha('navy', 0.18)}`;

// Left column is `position: sticky` inside the section's flex row, so it
// stays pinned in the viewport while the right column's beats + references
// scroll past, releasing naturally once the section ends. `alignSelf:
// 'flex-start'` is required for sticky to take effect on a flex child.
const ScienceSectionDesktop = () => (
  <div style={{ display: 'flex', width: '100%', backgroundColor: SHELL_WHITE }}>
    <div
      style={{
        width: 600,
        flexShrink: 0,
        position: 'sticky',
        top: 0,
        alignSelf: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        padding: '140px 56px 80px 56px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ fontFamily: 'DM Sans', fontSize: 12, fontWeight: 500, letterSpacing: '0.15em', textTransform: 'uppercase', color: MUTED_GOLD }}>
        {SCIENCE_EYEBROW}
      </div>
      <div style={{ fontFamily: 'Instrument Serif', fontSize: 58, lineHeight: '112%', color: TWILIGHT_NAVY, maxWidth: 480 }}>
        {HEADLINE_REGULAR}
        <span style={{ fontStyle: 'italic' }}>{HEADLINE_ITALIC}</span>
        <sup style={{ fontSize: '0.5em' }}>1</sup>
      </div>
      <div style={{ fontFamily: 'DM Sans', fontSize: 16, lineHeight: '175%', color: TWILIGHT_NAVY, maxWidth: 420 }}>{MISSION_TEXT}</div>
    </div>

    {/* maxWidth caps line length on ultra-wide viewports; the Paper mockup was
        authored at a fixed 1440px frame and didn't need this, but the right
        column is `flex: 1` on the real (responsive) site. */}
    <div style={{ flex: 1, maxWidth: 840, padding: '140px 72px', boxSizing: 'border-box' }}>
      {SCIENCE_BEATS.map((beat, i) => (
        <div
          key={beat.title}
          style={{
            padding: '32px 0',
            // borderBottom: i < SCIENCE_BEATS.length - 1 ? DIVIDER : 'none',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ width: 6, height: 6, flexShrink: 0, borderRadius: '50%', backgroundColor: alpha(beat.accent, 1) }} />
            <div style={{ fontFamily: 'Instrument Serif', fontStyle: 'italic', fontSize: 24, color: TWILIGHT_NAVY }}>{beat.title}</div>
          </div>
          <div style={{ fontFamily: 'DM Sans', fontSize: 14, lineHeight: '175%', color: alpha('navy', 1), paddingLeft: 20, marginTop: 10 }}>
            {beat.description}
            <sup style={{ fontSize: '0.75em' }}>{beat.citation}</sup>
          </div>
        </div>
      ))}

      <div style={{ fontFamily: 'Instrument Serif', fontStyle: 'italic', fontSize: 32, lineHeight: '130%', color: TWILIGHT_NAVY, maxWidth: 620, marginTop: 56 }}>
        {CLOSING_STATEMENT}
      </div>

      <div style={{ marginTop: 56, paddingTop: 24, borderTop: DIVIDER }}>
        {REFERENCES.map((ref) => (
          <div key={ref.n} style={{ fontFamily: 'DM Sans', fontSize: 10, lineHeight: '160%', letterSpacing: '0.02em', color: alpha('navy', 0.45), marginBottom: 12 }}>
            {ref.n}. {ref.text}
          </div>
        ))}
        <div style={{ fontFamily: 'DM Sans', fontSize: 10, lineHeight: '160%', letterSpacing: '0.02em', color: alpha('navy', 0.45) }}>
          {REFERENCES_DISCLAIMER}
        </div>
      </div>
    </div>
  </div>
);

export default ScienceSectionDesktop;
